module.exports = __webpack_public_path__ + "img/indicacion.06a0b6e6.jpg";